(function() { window.GUID_c4404826_623f_4bba_a94d_09f796691f77 = { getGuid: function() { return "c4404826-623f-4bba-a94d-09f796691f77"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-best-improvements",
                        callback: (accordion, e) => {
                            const weeksPickerDropdownId = `dropdown-weeks-picker-best-improvements-section-${accordion.ContentId}`;
                            CS.DOM.$body.offon(`click.accordionbestimprovements${accordion.ContentId}`, `#${weeksPickerDropdownId} .list-item`, (e) => {
                                var _a;
                                const $item = $(e.currentTarget);
                                const extraValues = (_a = $item.attr("data-extravalues")) !== null && _a !== void 0 ? _a : "";
                                if (CS.Helper.isNullOrWhiteSpace(extraValues))
                                    return;
                                const data = JSON.parse(extraValues);
                                if (data == null)
                                    return;
                                const { url } = data;
                                if (CS.Helper.isNullOrWhiteSpace(url))
                                    return;
                                accordion.RefreshContent(() => { }, url);
                            });
                            accordion.$Content.offon(`click.accordionbestimprovements${accordion.ContentId}`, ".weeks-picker__arrow", (e) => {
                                var _a;
                                const $arrow = $(e.currentTarget);
                                const dataUrl = (_a = $arrow.attr("data-url")) !== null && _a !== void 0 ? _a : "";
                                if (CS.Helper.isNullOrWhiteSpace(dataUrl))
                                    return;
                                accordion.RefreshContent(() => { }, dataUrl);
                            });
                            accordion.$Content.offon(`click.accordionbestimprovements${accordion.ContentId}-2`, ".toggle-switch__item", (e) => {
                                var _a;
                                const $item = $(e.currentTarget);
                                const isSelected = $item.attr("data-selected") == "true";
                                if (isSelected) {
                                    return;
                                }
                                const url = (_a = $item.attr("data-url")) !== null && _a !== void 0 ? _a : "";
                                if (!url) {
                                    return;
                                }
                                accordion.RefreshContent(() => { }, url);
                            });
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=section.ready.js.map
